import gsap from "gsap";
const rangeMapper = (num, inMin, inMax, outMin, outMax) => ((num - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
const clampNumber = (num, a, b) => Math.max(Math.min(num, Math.max(a, b)), Math.min(a, b));
function initBlock(block) {
    var _a;
    const contentItems = block.querySelectorAll(".review-content");
    const navItems = block.querySelectorAll(".review-nav-item");
    const prevHeading = block.previousElementSibling;
    if (!contentItems || !navItems)
        return;
    const state = {
        count: contentItems.length,
        activeIndex: Math.round(contentItems.length / 2),
        activeColor: (_a = contentItems[Math.round(contentItems.length / 2)].dataset.color) !== null && _a !== void 0 ? _a : "#000",
        isAnimating: false,
    };
    console.log(state);
    const animationBase = {
        duration: 0.75,
        ease: "power1.InOut",
    };
    const animationStates = {
        content: {
            in: {
                scale: 1,
                opacity: 1,
                x: 0,
                "--extra-translation": "0px",
            },
            out: {
                scale: 0.6,
                opacity: 0,
                x: 0,
                "--extra-translation": "-500px",
            },
        },
    };
    const setActive = (targetIndex, isInitial = false) => {
        var _a;
        if (targetIndex === state.activeIndex && !isInitial)
            return;
        if (state.isAnimating)
            return;
        navItems[state.activeIndex].classList.remove("active");
        const nextColor = (_a = contentItems[targetIndex].dataset.color) !== null && _a !== void 0 ? _a : "#000";
        const tl = gsap.timeline({
            onStart: () => {
                contentItems[targetIndex].classList.add("absolute");
                state.isAnimating = true;
            },
            onComplete: () => {
                contentItems[state.activeIndex].classList.add("absolute");
                contentItems[targetIndex].classList.remove("absolute");
                state.activeIndex = targetIndex;
                state.activeColor = nextColor;
                state.isAnimating = false;
                navItems[state.activeIndex].classList.add("active");
            },
        });
        // Animate out current active item
        tl.to(contentItems[state.activeIndex], Object.assign(Object.assign({}, animationBase), animationStates.content.out), 0);
        // Animate in new item
        tl.fromTo(contentItems[targetIndex], Object.assign({}, animationStates.content.out), Object.assign(Object.assign({}, animationBase), animationStates.content.in), 0);
        // Transition background color
        tl.fromTo(block, {
            "--glow-color": state.activeColor,
        }, {
            "--glow-color": nextColor,
        }, 0);
        if (prevHeading) {
            tl.fromTo(prevHeading, {
                "--bold-color": state.activeColor,
            }, {
                "--bold-color": nextColor,
            }, 0);
        }
        // Animate the nav items
        navItems.forEach((item, navIndex) => {
            const indexDiff = targetIndex - navIndex;
            const isNegative = indexDiff < 0;
            const mappedTranslation = rangeMapper(Math.abs(indexDiff), 1, state.count / 2 - 1, 100, 250);
            const mappedScale = rangeMapper(Math.abs(indexDiff), 1, state.count / 2 - 1, 0.7, 0);
            const mappedBlur = rangeMapper(Math.abs(indexDiff), 1, state.count / 2 - 1, 1, 24);
            const mappedOpactiy = rangeMapper(Math.abs(indexDiff), 1, state.count / 2 - 1, 0.8, 0);
            const anim = {
                x: isNegative ? `-${mappedTranslation}%` : `${mappedTranslation}%`,
                scale: clampNumber(mappedScale, 0, 1),
                filter: `blur(${mappedBlur}px)`,
                opacity: mappedOpactiy,
            };
            if (indexDiff === 0) {
                anim.x = "0%";
                anim.scale = 1;
                anim.filter = "blur(0px)";
                anim.opacity = 1;
            }
            gsap.to(item, Object.assign({}, anim));
        });
    };
    navItems.forEach((item, index) => {
        item.addEventListener("click", setActive.bind(item, index, false));
    });
    setActive(state.activeIndex, true);
    contentItems.forEach((item, index) => {
        if (index !== state.activeIndex) {
            item.classList.add("absolute");
            gsap.set(item, Object.assign({}, animationStates.content.out));
            gsap.set(block, { "--glow-color": state.activeColor });
        }
    });
}
window.addNavigationCallback(() => {
    const blocks = document.querySelectorAll(".reviews");
    blocks.forEach(initBlock);
}, "init-reviews");
